export const version = "json-wallets/5.6.0";
